import viewDepositTemplate from './viewDeposit.template.html';

/*******************************************************************************
 * DepositList */
/**
 * @ngdoc   component
 * @module  depositHistory
 * @name    depositHistory.component:ViewDeposit
 * @description
 * Displays a detail Deposit for the organization.
 *******************************************************************************/
export const viewDepositComponent = {
  template: viewDepositTemplate,
  bindings: { isBoosterpta: '<', accountName: '<' },
  controller: DepositHistoryController
};

listColumnDirective.$inject = [];
/*-------------------------------------------------------------*/
/* function listColumn() will build the divs to insert within  */
/* the Grid. Will determine field, and format/fill accordingly */
/*-------------------------------------------------------------*/
/* @ngInject */ export function listColumnDirective() {
  controller.$inject = ['$sce', '$scope', '$filter'];

  /* @ngInject */ function controller($sce, $scope, $filter) {
    $scope.makeMultiColumn = function (field, sale) {
      /*--------------*/
      /* Details Divs */
      /*--------------*/
      var dta = '<div >#DTA#</div>'; // default data
      var dtaCurrncy = "<div style='text-align:right'>#DTA#</div>"; // currency data
      var wdta = '';
      /*-----------------------------------------------------------------------*/
      /* Got a row of data to fill. Cycle thru, filling in the data columns    */
      /* with the data within th object. NOTE: Two amounts, uses j to          */
      /* determin if the amount is the toal amount vs j>0 for the item amount. */
      /*-----------------------------------------------------------------------*/
      for (var i = 0; i < sale.saleItemTotals.length; i++) {
        switch (field) {
          case 'totalAmount':
            sale.amount = sale.amount
              ? sale.amount
              : sale.saleItemTotals[i].amount;
            wdta =
              wdta +
              (i == 0
                ? dtaCurrncy.replace('#DTA#', $filter('number')(sale.amount, 2))
                : dta.replace('#DTA#', '&nbsp;'));
            break;
          case 'description':
            wdta =
              wdta +
              dta.replace(
                '#DTA#',
                sale.saleItemTotals[i].description
                  ? sale.saleItemTotals[i].description
                  : '&nbsp;'
              );
            break;
          case 'accountNumber':
            wdta =
              wdta + dta.replace('#DTA#', sale.saleItemTotals[i].accountNumber);
            break;
          case 'accountName':
            wdta =
              wdta + dta.replace('#DTA#', sale.saleItemTotals[i].accountName);
            break;
          case 'amount':
            wdta =
              wdta +
              dtaCurrncy.replace(
                '#DTA#',
                $filter('number')(sale.saleItemTotals[i].amount, 2)
              );
            break;
          case 'receiptDate':
            var mDate = sale.receiptDate
              ? $filter('date')(sale.receiptDate, 'MM/dd/yyyy')
              : '&nbsp;';
            wdta =
              wdta +
              (i == 0
                ? dta.replace('#DTA#', mDate)
                : dta.replace('#DTA#', '&nbsp;'));
            break;
          case 'receiptNumber':
            var mRecNum = sale.receiptNumber ? sale.receiptNumber : '&nbsp';
            wdta =
              wdta +
              (i == 0
                ? dta.replace('#DTA#', mRecNum)
                : dta.replace('#DTA#', '&nbsp;'));
            break;
          case 'receiptFrom':
            var mRecFrom = sale.receiptFrom ? sale.receiptFrom : '&nbsp';
            wdta =
              wdta +
              (i == 0
                ? dta.replace('#DTA#', mRecFrom)
                : dta.replace('#DTA#', '&nbsp;'));
            break;
          case 'extBatchID':
            /**
             * Only for KPS/Nuvei payments there will only ever be 1 payment attached to
             * a sale, so we can just grab the first payment's batch ID. This will be the batch
             * ID for the receipt.
             */
            var mBatchID = sale?.payments[0]?.extBatchID ?? '&nbsp';
            wdta =
              wdta +
              (i == 0
                ? dta.replace('#DTA#', mBatchID)
                : dta.replace('#DTA#', '&nbsp;'));
            break;
        }
      }
      return $sce.trustAsHtml(wdta);
    };
  }

  return {
    restrict: 'E',
    template:
      '<div class="ui.grid ui-grid-cell-contents" ng-bind-html="makeMultiColumn(col.colDef.field, row.entity)"></div>',
    controller: controller
  };
}

/*******************************************************************************
 * DepositListController */
/**
 * @ngdoc   controller
 * @module  depositHistory
 * @name    depositHistory.controller:DepositHistoryController
 * @description
 * Controller for the {@link depositHistory.component:ViewDeposit}
 * component.
 *******************************************************************************/
/* @ngInject */ function DepositHistoryController(
  $location,
  $routeParams,
  BusyScreen,
  DepositHistoryService,
  uiGridConstants,
  PrintDeposit,
  Tools,
  SERVER
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /* Deposit ID */ var mDepositID = $routeParams.id;
  /** Self Reference. */ var mThis = this;
  /** Print dialog is open. */ var mPrintDialogOpen = false;
  /* Close the summary */ mThis.salesSummaryCollapsed = true;
  /* Close the detail */ mThis.salesDetailCollapsed = true;

  var saleItemsTemplate = '<list-column name="salesName" />';

  /***************************************************************************
   * loadSummary */
  /**
   * Loads the Summary of Deposit for the organization.
   ***************************************************************************/
  function loadSummary() {
    return DepositHistoryService.getSummary(mDepositID).then(function (data) {
      mThis.summaryItems = data;
      /* items */ var mItems = data.items;

      /*-----------------------*/
      /* Set the details data. */
      /*-----------------------*/
      mThis.dgSalesDetail.data = mItems;

      /***
       * Only add this column for kps deposits.
       */
      if (SERVER.BooksDBConstants.LES_KPS == mThis.summaryItems.source) {
        mThis.dgSalesDetail.columnDefs.unshift({
          displayName: 'Batch',
          field: 'extBatchID',
          cellClass: 'detailFill',
          minWidth: 80,
          width: '8%',
          cellTemplate: saleItemsTemplate
        });
      }

      /*------------------------*/
      /* Check for adjustments. */
      /*------------------------*/
      mThis.showAdjustment = !Tools.isNaNZero(
        mThis.summaryItems.adjustAccountID
      );

      /*------------------------------------*/
      /* If there is an adjustment, display */
      /* a message about the adjustment.    */
      /*------------------------------------*/
      if (mThis.showAdjustment) {
        var amount = mThis.summaryItems.adjustmentAmount * -1;
        var acctNumber = mThis.isBoosterpta
          ? ''
          : ' (' + mThis.summaryItems.adjustAccountNumber + ')';
        mThis.adjustText =
          'Missing Items Adjustment of ' +
          amount.toFixed(2) +
          ' to ' +
          mThis.summaryItems.adjustAccountName +
          acctNumber;
      }

      /*-----------------------*/
      /* Set the summary data. */
      /*-----------------------*/
      var reduced = mItems.reduce(function (map, item) {
        /*----------------------------------------------*/
        /* Loop through the saleItemTotals for each     */
        /* item and sum the amounts for each accountID. */
        /*----------------------------------------------*/
        item.saleItemTotals.forEach(function (acct) {
          /*----------------------------------------------------------------------*/
          /* We want to create a total for each item that has the same accountID, */
          /* accountName and description. The acctString is a concatenation of    */
          /* all of these fields and is used in the map for totaling accounts.    */
          /*----------------------------------------------------------------------*/
          var acctString =
            acct.accountID.toString() + acct.accountName + acct.description;

          /*------------------------------------------------*/
          /* If the map object does not have the acctString */
          /* being looked at, create the object on the map. */
          /*------------------------------------------------*/
          if (!map[acctString])
            map[acctString] = {
              accountID: acct.accountID,
              accountName: acct.accountName,
              accountNumber: acct.accountNumber,
              total: 0,
              description: acct.description
            };

          map[acctString].total = Tools.roundMoney(
            map[acctString].total + acct.amount
          );
        });

        return map;
      }, {});

      /*----------------------------*/
      /* Set the sales summary data */
      /*----------------------------*/
      mThis.dgSalesSummary.data = Object.keys(reduced)
        .map(function (key) {
          return reduced[key];
        })
        .sort(function (a1, a2) {
          a1.description = Tools.isEmpty(a1.description) ? '' : a1.description;
          a2.description = Tools.isEmpty(a2.description) ? '' : a2.description;
          return a1.description
            .toLowerCase()
            .localeCompare(a2.description.toLowerCase());
        });
    });
  }

  /*****************************************************************************
   * $onInit */
  /**
   * @ngdoc     method
   * @module    depositHistory
   * @methodOf  depositHistory.controller.ViewHistoryController
   * @name      $onInit
   * @description
   * Initializes the application with the requested bank statement.
   *****************************************************************************/
  mThis.$onInit = function () {
    /*------------------------*/
    /* Detail grid properties */
    /*------------------------*/
    mThis.dgSalesDetail = {
      enableColumnMenus: false,
      enableRowHeaderSelection: false,
      enableSorting: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        mThis.dgSalesDetail.api = gridApi;
        mThis.dgSalesDetail.loaded = true;
      },
      data: [],
      columnDefs: [
        {
          displayName: 'Date',
          field: 'receiptDate',
          cellClass: 'detailFill',
          minWidth: 80,
          width: '9%',
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'Rec No.',
          field: 'receiptNumber',
          cellClass: 'detailFill',
          minWidth: 80,
          width: '8%',
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'From',
          field: 'receiptFrom',
          cellClass: 'detailFill',
          minWidth: 80,
          width: '15%',
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'Total',
          field: 'totalAmount',
          cellClass: 'detailFill',
          minWidth: 80,
          width: '10%',
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'Description',
          field: 'description',
          cellClass: 'detailFill',
          minWidth: 100,
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'Acct No',
          field: 'accountNumber',
          cellClass: 'detailFill',
          minWidth: 100,
          width: '10%',
          cellTemplate: saleItemsTemplate,
          visible: !mThis.isBoosterpta
        },
        {
          displayName: mThis.accountName,
          field: 'accountName',
          cellClass: 'detailFill',
          minWidth: 100,
          width: '19%',
          cellTemplate: saleItemsTemplate
        },
        {
          displayName: 'Amount',
          field: 'amount',
          cellClass: 'detailFill',
          minWidth: 100,
          width: '9%',
          cellTemplate: saleItemsTemplate
        }
      ]
    };

    /*-------------------------*/
    /* Summary grid properties */
    /*-------------------------*/
    mThis.dgSalesSummary = {
      enableColumnMenus: false,
      enableSorting: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        mThis.dgSalesSummary.api = gridApi;
        mThis.dgSalesSummary.loaded = true;
      },
      multiSelect: false,
      data: [],
      columnDefs: [
        {
          displayName: 'Account Number',
          minWidth: 120,
          field: 'accountNumber',
          width: '20%',
          visible: !mThis.isBoosterpta,
          defaultSort: { direction: uiGridConstants.ASC, priority: 0 }
        },
        { displayName: mThis.accountName, minWidth: 200, field: 'accountName' },
        { displayName: 'Description', minWidth: 200, field: 'description' },
        {
          displayName: 'Amount',
          minWidth: 100,
          field: 'total',
          width: '10%',
          cellFilter: 'number: 2',
          cellClass: 'grid-align'
        }
      ]
    };

    /*--------------------*/
    /* Initialize the app */
    /*--------------------*/
    BusyScreen.promise(loadSummary());
  };

  /*****************************************************************************
   * printStatement */
  /**
   * @ngdoc     method
   * @module    printDeposit
   * @methodof  printDeposit.controller:DepositHistorytListController
   * @name      printStatement
   *
   * @description
   * Handles the print action. The print dialog will be displayed to allow
   * selection of the report type and detail option.
   *****************************************************************************/
  mThis.printStatement = function () {
    mPrintDialogOpen = true;
    PrintDeposit.show(mDepositID, mThis.isBoosterpta).finally(function () {
      mPrintDialogOpen = false;
    });
  };

  /*****************************************************************************
   * returnToMain */
  /**
   * @ngdoc     method
   * @module    depositHistory
   * @methodof  depositHistory.controller:depositHistoryController
   * @name      returnToMain
   * @description
   * Returns to the main route.
   *****************************************************************************/
  mThis.returnToMain = function () {
    //      sessionStorage.setItem('previousAccount', mThis.summaryItems.bankAccountName);
    $location.path('/');
  };
}
